<script setup lang="ts">
import { Vue3Marquee } from "vue3-marquee";
import "vue3-marquee/dist/style.css";
</script>

<template>
    <Vue3Marquee :clone="true" gradient-width="0px">
        <slot></slot>
    </Vue3Marquee>
</template>

<style lang="scss" scoped></style>
